import LockerRentals from "./Locker Rentals";
import LoanAccounts from "./Loan Accounts";
import Customer from "./Customers";
import AccountActivity from "./Account Activity";
import DepositAccounts from "./Deposit Accounts";
import GeneralAccounts from "./General Accounts";

export default {
  ...LockerRentals,
  ...LoanAccounts,
  ...Customer,
  ...AccountActivity,
  ...DepositAccounts,
  ...GeneralAccounts
};
